import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import luniaCoreLogo from './assets/LUNIA_CORE.png';

for (const rel of ['icon', 'apple-touch-icon'] as const) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.rel = rel;
    document.head.appendChild(el);
  }
  el.setAttribute('type', 'image/png');
  el.setAttribute('href', luniaCoreLogo);
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
